var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.s_market_info)?_c('B2CExchange',{key:_vm.s_market_info ? _vm.s_market_info.seq : null}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }